import { render, staticRenderFns } from "./OptInFormBuilder.vue?vue&type=template&id=1b61c8de&lang=pug"
import script from "./OptInFormBuilder.vue?vue&type=script&lang=js"
export * from "./OptInFormBuilder.vue?vue&type=script&lang=js"
import style0 from "./OptInFormBuilder.vue?vue&type=style&index=0&id=1b61c8de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports